export const SET_CONTACTS = 'SET_CONTACTS'
export const SET_STATUS_MESSAGE = 'SET_STATUS_MESSAGE'
export const SET_LODING_STATUS = 'SET_LODING_STATUS'
export const CLEAR_LODING_STATUS = 'CLEAR_LODING_STATUS'
